var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"cols":"12","lg":"12","xl":"4"}},[_c('v-subheader',{staticClass:"body-3 ml-n3"},[_vm._v(_vm._s(_vm.$t('stats.lol.ai_column_title')))]),_c('ChampSkillScore'),_c('UniqueChamps'),_c('WnrGraph',{staticClass:"mt-2"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }